import {environment} from '../constants-enumerate';

const IGNORE_ERRORS = ['Route Not Found'];

const getEnvironment = () => {
  if (environment.DEV) return 'development';
  if (environment.STAGE) return 'staging';
  if (environment.PROD) return 'production';
};

const initConfig = {
  dsn: 'https://c1669e1c083647bb8ac838e2b0ba6b49@o968153.ingest.us.sentry.io/4504934404784128',
  release: process.env.RELEASE_TAG,
  tracesSampleRate: environment.PROD ? 0.05 : 0,
  normalizeDepth: 5,
  environment: getEnvironment(),
  ignoreErrors: IGNORE_ERRORS,
};

export {
  initConfig
};
